import { APITypes } from "@cur8/api-client";

export function hasBeenInformedAbout(
  document: string,
  consents: APITypes.ConsentSummary[]
) {
  return consents.some(
    ({ documentUrl, expired }) =>
      documentUrl.includes(document) && expired === false
  );
}
